import React from 'react';

import { HtmlDescription } from '@/graphql/generated';
import { useUserTrackingConsent } from '@/hooks';

import { LoadingConsentPlaceholder } from './components/loading-consent-placeholder';
import { HTMLDescriptionComponent } from './html-description-component';

interface Props {
  description: HtmlDescription;
}

export const HTMLDescriptionContainer: React.VFC<Props> = ({ description }) => {
  const { loading, hasTrackingConsent } = useUserTrackingConsent();

  if (loading) {
    return <LoadingConsentPlaceholder />;
  }

  return <HTMLDescriptionComponent description={description} hasTrackingConsent={hasTrackingConsent} />;
};
